<script lang="ts">
  import { intersection } from "@opera-gx/common/src/actions/intersection";
  import { onDestroy, onMount } from "svelte";
  import { fade } from "svelte/transition";

  import Tile from "./Tile.svelte";
  export let url: string;
  export let title: string;
  export let image: string;
  export let publisher_name: string;
  export let publisher_favicon: string;
  export let index: number;
  let intersecting = false;
  let loaded = false;
  let showPlaceholder = false;
  let color: string;
  let imgLoaded = false;
  let failed = false;
  const getTileGradientDirection = (index: number) => (index % 2 ? "tl" : "br");
  let timeout: NodeJS.Timeout;
  onMount(() => {
    timeout = setTimeout(() => {
      showPlaceholder = true;
    }, 1000);

    const img = new Image();
    img.src = image;

    img.onload = () => {
      imgLoaded = true;
    };

    img.onerror = () => {
      failed = true;
    };
  });
  onDestroy(() => {
    clearTimeout(timeout);
  });
</script>

<style lang="scss">
  .tile {
    background-color: hsl(var(--color-N08));
    border-radius: 8px;
    display: block;
    font-family: system-ui;
    font-size: 13px;
    font-style: normal;
    font-weight: 650;
    overflow: hidden;
    text-decoration: none;
    max-width: 338px;
    max-height: 282px;
  }

  .image {
    aspect-ratio: 16 / 9;
    min-height: 169px;
    overflow: hidden;
    width: 100%;
  }

  img {
    height: 100%;
    object-fit: cover;
    transform: translate3d(0, 0, 0);
    transition: transform 1s ease-out 0s;
    width: 100%;
  }

  .source {
    font-weight: 400;
    padding: 12px;
    color: hsl(var(--color-N100, var(--color-N77)));
  }

  .source::before {
    --size: 16px;

    background: var(--favi);
    background-size: var(--size) var(--size);
    content: "";
    display: inline-block;
    height: var(--size);
    margin: 0 8px 0 0;
    vertical-align: text-bottom;
    width: var(--size);
  }

  .title {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 16px;
    height: 35px;
    -webkit-line-clamp: 2;
    line-height: 17px;
    margin: 0 8px 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: hsl(var(--color-N100, var(--color-N77)));
  }
</style>

{#if imgLoaded && !failed}
  <a href={url} rel="noreferrer" target="_blank" style="max-width: 600px;">
    <div
      class="wrapper"
      class:show={intersecting && (loaded || showPlaceholder)}
      style="transition-delay: {40 * index}ms;"
      use:intersection={{
        handler: (entries) => {
          if (!entries.some(({ isIntersecting }) => isIntersecting)) {
            intersecting = false;
            return;
          }

          if (entries.some(({ intersectionRatio }) => intersectionRatio >= 0.05)) {
            intersecting = true;
            return;
          }
        },
        rootMargin: "100% 0px 0px 0px",
        threshold: [0, 0.05],
      }}>
      <Tile cut={20} let:class={tile}>
        <div
          class={`${tile} to-accent/40 from-transparent after:bg-gradient-to-${getTileGradientDirection(
            index,
          )} after:to-accent
after:from-transparent after:via-transparent
`}
          style={`--favi: url("${publisher_favicon || ""}")`}>
          <div class="source">{publisher_name}</div>
          <div class="title text-{color}">{title}</div>
          <div class="image">
            <img draggable="false" in:fade={{ duration: 500 }} alt={title} src={image} />
          </div>
        </div>
      </Tile>
    </div>
  </a>
{/if}
